import * as React from 'react';
import { filter, isEmpty } from 'lodash';

import Button from 'components/ButtonDeprecated';
import LayerTrigger from 'components/LayerTrigger';

import { Props as ButtonProps } from 'components/ButtonDeprecated';

type DefaultProps = {
  alignment: 'top' | 'right' | 'bottom' | 'left' | 'middle';
  placement: 'top' | 'right' | 'bottom' | 'left';
};

type Props = {
  activeClassName?: string;
  children: React.ReactNode;
  disabled?: boolean;
  hideLayerOnScroll?: boolean;
  menu: React.ReactElement;
  tooltip?: React.ReactNode;
  tooltipAlignment?: 'top' | 'right' | 'bottom' | 'left';
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
} & DefaultProps &
  ButtonProps;

export default class MenuButton extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    alignment: 'left',
    placement: 'bottom',
  };

  render() {
    const {
      activeClassName,
      alignment,
      children,
      disabled,
      hideLayerOnScroll,
      menu,
      placement,
      tooltip,
      tooltipAlignment,
      tooltipPlacement,
      ...other
    } = this.props;

    const dataTestId = this.props['data-testid'];

    const hasMenuItems = !isEmpty(filter(menu.props.children, Boolean));

    if (!hasMenuItems) {
      return null;
    }

    const button = (
      <Button
        {...other}
        disabled={this.props.disabled}
        tooltip={tooltip}
        tooltipAlignment={tooltipAlignment}
        tooltipPlacement={tooltipPlacement}
        data-testid={dataTestId}
      >
        {children}
      </Button>
    );

    if (disabled) {
      return button;
    }

    return (
      <LayerTrigger
        alignment={alignment}
        hideLayerOnScroll={hideLayerOnScroll}
        layer={menu}
        placement={placement}
        trigger="click"
        activeClassName={activeClassName}
      >
        {button}
      </LayerTrigger>
    );
  }
}
